import { useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";

/**
 * Hook to check if current user has admin privileges
 * Returns { isAdmin: boolean, isLoading: boolean }
 */
export function useIsAdmin() {
  const isAdmin = useQuery(api.audioLibrary.isCurrentUserAdmin);

  return {
    isAdmin: isAdmin ?? false,
    isLoading: isAdmin === undefined,
  };
}
